import {
  Buildings,
  Category,
  Notification,
  Health,
  InfoCircle,
  Money,
  Profile2User,
  Setting2,
  Sms,
  Shop,
  Video,
  Refresh2,
  MoneyRecive,
  Global,
  Star1
} from "iconsax-react";

const menu = [
  {
    id: 1,
    title: "Overview",
    path: "/dashboard/overview",
    icon: <Category size={22} variant="Bold" />,
    section: 1,
  },

  {
    id: 9,
    title: "eRX",
    path: "/dashboard/orders",
    icon: <Shop size={22} variant="Bold" />,
    section: 1,
  },
  {
    id: 2,
    title: "Patients",
    path: "/dashboard/patients",
    icon: <Profile2User size={22} variant="Bold" />,
    section: 1,
  },

  {
    id: 88,
    title: "Refill Requests",
    path: "/dashboard/refill-requests",
    icon: <Refresh2 size={22} variant="Bold" />,
    section: 2,
    action: "refillRequests",
  },
  {
    id: 3,
    title: "Messages",
    path: "/dashboard/messages",
    icon: <Sms size={22} variant="Bold" />,
    section: 2,
    action: "msgs",
  },
  {
    id: 8,
    title: "Notifications",
    path: "/dashboard/notifications",
    icon: <Notification size={22} variant="Bold" />,
    section: 2,
    action: "notifs",
  },

  {
    id: 10,
    title: "Invoices",
    path: "/dashboard/invoices",
    icon: <Money size={22} variant="Bold" />,
    section: 1,
    adminOnly: true,
  },
  {
    id: 4,
    title: "Facility",
    path: "/dashboard/facility",
    icon: <Buildings size={22} variant="Bold" />,
    section: 1,
  },

  {
    id: 6,
    title: "Subscription",
    path: "/dashboard/billing",
    icon: <Money size={22} variant="Bold" />,
    section: 3,
    adminOnly: true,
  },,
  {
    id: 5,
    title: "Settings",
    path: "/dashboard/settings/personal-info",
    icon: <Setting2 size={22} variant="Bold" />,
    section: 3,
  },

  {
    id: 20,
    title: "Telemedicine",
    path: "/dashboard/telemedicine",
    icon: <Video size={22} variant="Bold" />,
    section: 1,
  },

  {
    id: 7,
    title: "Support",
    path: "/dashboard/support",
    icon: <InfoCircle size={22} variant="Bold" />,
    section: 3,
  },
  {
    id: 13,
    title: "Earnings",
    path: "/dashboard/earnings",
    icon: <MoneyRecive size={22} variant="Bold" />,
    section: 2,
    adminOnly: true,
  },
  {
    id: 14,
    title: "CMS",
    path: "/dashboard/cms",
    icon: <Global size={22} variant="Bold" />,
    section: 3,
    adminOnly: true,
    hasSubmenu: true,
    submenu: [
      {
        id: 141,
        title: "Treatments",
        path: "/dashboard/cms/treatments",
        icon: <Health size={20} variant="Bold" />,
      },
      {
        id: 142,
        title: "Products",
        path: "/dashboard/cms/products",
        icon: <Shop size={20} variant="Bold" />,
      },
      {
        id: 143,
        title: "Testimonials",
        path: "/dashboard/cms/testimonials",
        icon: <Star1 size={20} variant="Bold" />,
      },
    ],
  },
];

export default menu;
